export default "__VITE_ASSET__c992ea3a__"